import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { CampaignGatekeeperModel } from 'src/app/models/CampaignGatekeeperModel';

@Component({
  selector: 'app-gate-keeper',
  templateUrl: './gate-keeper.component.html',
  styleUrls: ['./gate-keeper.component.css']
})
export class GateKeeperComponent implements OnInit {
    get model() { return this._model; }
    @Input() set model(value: CampaignGatekeeperModel[]) {
        this._model = value;
        if (value !== null) {
            this.initForm();
        }
    }

    @Output() answered = new EventEmitter();

    gateAnswer: FormControl;
    count = 0;
    correct = true;

    private _model: CampaignGatekeeperModel[];

  constructor() { }

  ngOnInit(): void {
  }

  private initForm(): void {
      this.gateAnswer = new FormControl(null);
      this.gateAnswer.valueChanges.subscribe(checked => {
           this.answered.emit();
      });
    }


    // this.requestForm.controls.neededTreeship.valueChanges.subscribe(checked => {
    //     if (checked) {
    //       this.requestForm.controls.ifTreeshipParagraph.setValidators([Validators.required]);
    //     } else {
    //       this.requestForm.controls.ifTreeshipParagraph.setValidators(null);
    //     }
    //     this.requestForm.controls.ifTreeshipParagraph.updateValueAndValidity();
    //   });


next(n: number): boolean{
    const a = this.gateAnswer.value === 'Yes' ? 1 : 0;
    if (a === this.model[this.count].cgCorrectAnswer){
        this.count = n;
        this.initForm();
        return this.correct;
     }
    this.correct = false;
    return this.correct;

 }

 reInitStep(n: number): void {
    this.count = n;
    this.correct = true;
    this.initForm();
 }


get f(): any { return this.gateAnswer; }

}
